import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseSubjectSyllabusService} from '../../../shared/services/popular-course-subject-syllabus.service';

interface SyllabusSemester {
    label: string;
    subjects: string[];
}

import {UtilsService} from '../../../shared/services/utils.service';
import {environment} from '../../../../environments/environment';
@Component({
    selector: 'app-popular-course-subject-syllabus',
    templateUrl: './popular-course-subject-syllabus.component.html',
    styleUrls: ['./popular-course-subject-syllabus.component.scss']
})
export class PopularCourseSubjectSyllabusComponent implements OnInit {
    public popularCourseId: any;
    submitting: any = false;
    dataExists: any = false;
    // Superseded by the rich table editor below (table_html) — kept commented out for now
    // in case the structured semester/subject table needs to come back.
    // semesters: SyllabusSemester[] = [];
    editorBlocks: Array<{type: 'content' | 'table', value: string}> = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseSubjectSyllabusService: PopularCourseSubjectSyllabusService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.popularCourseSubjectSyllabusService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.dataExists = !!(data && data['info']);

            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];

            // this.semesters = (data && data['table_data'] && data['table_data'].length) ? data['table_data'] : [];
            // if (this.semesters.length === 0) {
            //     this.addSemester();
            // }
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    // addSemester() {
    //     this.semesters.push({label: `Semester ${this.semesters.length + 1}`, subjects: ['']});
    // }
    //
    // removeSemester(index: number) {
    //     this.semesters.splice(index, 1);
    // }
    //
    // addSubject(semesterIndex: number) {
    //     this.semesters[semesterIndex].subjects.push('');
    // }
    //
    // removeSubject(semesterIndex: number, subjectIndex: number) {
    //     this.semesters[semesterIndex].subjects.splice(subjectIndex, 1);
    // }

    submit() {
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);

        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
            // 'table_data': cleanedSemesters — commented out along with the structured table UI above
        };
        this.submitting = true;
        if (this.dataExists) {
            this.popularCourseSubjectSyllabusService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        } else {
            this.popularCourseSubjectSyllabusService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
            });
        }
    }
}
